
export const DragTypes = {
   EVENT: "event",
   PLANNER_VEHICLE: "planner-vehicle",
}
